<template>
    <div class="pay-car">
        <div class="pay-car-title">预约付款</div>
        <div class="pay-car-price">支付金额：<span class="color-red f-20 fw-b">{{price|parseMoney}}</span></div>
        <div class="pay-car-price">请选择支付方式：</div>
        <PaySelect @change="handleChange"></PaySelect>
        <img class="code-img" v-if="codeData" :src="codeData" alt="">
        <el-button type="primary" :loading="loading" @click="carPay">确认支付</el-button>
        <div class="pay-car-price">点击“确认支付”即表示已阅读和同意 <span class="color-red">《东瀛民宿接送机协议和条款》</span></div>
    </div>
</template>

<script>
    import PaySelect from "./PaySelect";
    import QRcode from "qrcode";
    export default {
        name: "PayCar",
        components:{PaySelect},
        props: {
            price: {
                type: Number,
                default: 0
            },
            orderMum: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                loading: false,
                payment: '',
                codeData: ''
            }
        },
        methods: {
            handleChange(e) {
                if (e === 1) {
                    this.payment = 'ali_pc'
                } else if (e === 2) {
                    this.payment = 'wx_pc'
                }
            },
            async carPay() {
                this.loading = true;
                let [e, data] = await this.$api.carPayApi({
                    payment: this.payment,
                    coding: this.orderMum,
                })
                this.loading = false;
                if (data.status) {
                    if (this.payment === 'ali_pc') {
                        this.aliPay(data.result)
                    } else if (this.payment === 'wx_pc') {
                        this.wxPay(data.result)
                    }
                }

            },
            aliPay(params) {
                let temp = document.createElement("form");
                temp.action = 'https://openapi.alipay.com/gateway.do?charset=utf-8'
                temp.method = "post";
                temp.target = "_blank";
                temp.style.display = "none";
                let strs = params.split('&');
                for (let v of strs) {
                    let arr = v.split('=');
                    let opt = document.createElement("input");
                    opt.name = arr[0];
                    opt.value = decodeURIComponent(arr[1]);
                    temp.appendChild(opt);
                }
                document.body.appendChild(temp);
                temp.submit();
            },
            async wxPay(str){
                let res = await QRcode.toDataURL(str);
                this.codeData = res;
            }
        },
    }
</script>

<style scoped lang="less">
    .pay-car {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;

        .pay-car-title {
            font-size: 18px;
            font-weight: bold;
        }
        .pay-car-price{
            font-size: 14px;
            margin-top: 20px;
        }
    }
    .code-img{
        width: 300px;
        height: 300px;
        margin: 20px 0;
    }
</style>
